import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineFileImage, AiOutlineFilePdf } from "react-icons/ai";
import { Modal, ScrollArea, ScrollAreaAutosize, Text } from "@mantine/core";

import { truncateWithEllipsis } from "@utils/truncateText";

import { MAX_FILENAME_LENGTH_AFTER_UPLOAD } from "@constants/index";

import { useAuth } from "@contexts/auth";

import { StyledAnalysisPrescriptionDocumentsModalContent } from "./AnalysisPrescriptionDocumentsModal.styled";


interface ModalProps {
  files: string[];
  opened: boolean;
  close: () => void;
}

const MAX_FILENAME_LENGTH = MAX_FILENAME_LENGTH_AFTER_UPLOAD + 5;

export const AnalysisPrescriptionDocumentsModal = ({
  opened,
  close,
  files: initialFiles,
}: ModalProps) => {
  const { t } = useTranslation();
  const { token } = useAuth();

  const [files, setFiles] = useState<string[]>([]);

  useEffect(() => {
    if (initialFiles?.length) {
      setFiles(initialFiles);
    }
  }, [initialFiles]);

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      title={<Text fw={500}>{t("analysis-prescription-documents")}</Text>}
      scrollAreaComponent={ScrollAreaAutosize}>
      <StyledAnalysisPrescriptionDocumentsModalContent>
        <div className="files-wrapper">
          <div className="uploaded-files">
            <ScrollArea className={"previous-files"}>
              {files?.length ? (
                <ul>
                  {files.reverse().map((file, index) => (
                    <li key={index}>
                      <div className="content">
                        {(file as string).slice(-3) === "pdf" ? (
                          <AiOutlineFilePdf />
                        ) : (
                          <AiOutlineFileImage />
                        )}
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={"https://" + file + `?token=${token}`}>
                          {truncateWithEllipsis(
                            (file as string).split("/")[3],
                            MAX_FILENAME_LENGTH
                          )}
                        </a>
                      </div>

                      {/* <Tooltip label={t("delete-lab-file")} withArrow>
                        <ActionIcon
                          color="red"
                          loading={
                            isDeleteLabFileLoading && fileIndex === index
                          }
                          variant="outline"
                          onClick={() => {
                            setFileIndex(index);
                            openDeleteModal({
                              textNode: (
                                <Text fz={"sm"}>
                                  {t("delete-lab-file-message")}
                                </Text>
                              ),
                              onConfirm: () => {
                                if (lab?.id) {
                                  deleteLabFile(
                                    {
                                      labId: lab.id,
                                      fileName: (file as string).split("/")[3],
                                      patientId: lab.patientId as string,
                                    },
                                    {
                                      onSuccess: () =>
                                        setfiles(
                                          files.filter(
                                            (_, idx) => idx !== index
                                          )
                                        ),
                                    }
                                  );
                                }
                              },
                            });
                          }}>
                          <IconTrash size={16} />
                        </ActionIcon>
                      </Tooltip> */}
                    </li>
                  ))}
                </ul>
              ) : (
                <Text c="dimmed" fz={14}>
                  {t("empty-files")}
                </Text>
              )}
            </ScrollArea>
          </div>
        </div>
      </StyledAnalysisPrescriptionDocumentsModalContent>
    </Modal>
  );
};
